import { ILocalized, IPage } from '@websolutespa/bom-core';
import React from 'react';
import { createGenericContext } from '../useGenericContext/useGenericContext';

export type IPageContext = ILocalized<IPage>;

const [usePage, PageContextProvider] = createGenericContext<IPageContext>();

function PageProvider({ children, page }: { children?: React.ReactNode, page: ILocalized<IPage> }) {
  return (
    <PageContextProvider value={page}>
      {children}
    </PageContextProvider>
  );
}

export { PageProvider, usePage };

